import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { NotificationService } from "src/app/shared/isolutions-ui/feedback/notifications/notification.service";
import { ApiResponse } from "../models/api-response.model";
import { Contractor } from "../models/contractor.model";
import { BaseApiService } from "./base-api.service";
import { SpinnerService } from "./spinner.service";

@Injectable({ providedIn: "root" })
export class ContractorService extends BaseApiService {
  constructor(
    http: HttpClient,
    notify: NotificationService,
    translate: TranslateService,
    spinner: SpinnerService,
  ) {
    super(http, notify, translate, spinner);
  }

  getAvailable(): Observable<ApiResponse<Contractor>> {
    return this.get<Contractor>("Contractor");
  }
}
